import React, { useEffect, useState, useRef } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Box } from '@mui/material';

function RichTextEditor({ value, onChange, placeholder }) {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const skipNextUpdate = useRef(false);

  // Initialize editor content when value prop changes
  useEffect(() => {
    if (value && !skipNextUpdate.current) {
      const contentBlock = htmlToDraft(value);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const newEditorState = EditorState.createWithContent(contentState);
        setEditorState(newEditorState);
      }
    }
    skipNextUpdate.current = false;
  }, [value]);

  const handleEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
    skipNextUpdate.current = true;
    
    if (onChange) {
      const html = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));
      onChange(html);
    }
  };

  return (
    <Box sx={{ 
      border: 1, 
      borderColor: 'divider',
      borderRadius: 1,
      '& .rdw-editor-wrapper': {
        border: 'none'
      },
      '& .rdw-editor-toolbar': {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        marginBottom: 0,
        paddingBottom: 1,
      },
      '& .rdw-editor-main': {
        padding: 2,
        minHeight: '200px',
        maxHeight: '500px',
        overflow: 'auto',
      }
    }}>
      <Editor
        editorState={editorState}
        onEditorStateChange={handleEditorStateChange}
        placeholder={placeholder}
        toolbar={{
          options: ['inline', 'blockType', 'list', 'link', 'emoji', 'history'],
          inline: {
            options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace'],
          },
          blockType: {
            options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code'],
          },
          list: {
            options: ['unordered', 'ordered'],
          },
        }}
      />
    </Box>
  );
}

export default RichTextEditor; 